import { render, staticRenderFns } from "./MnemonicTip.vue?vue&type=template&id=28cfac5a&scoped=true&"
import script from "./MnemonicTip.vue?vue&type=script&lang=js&"
export * from "./MnemonicTip.vue?vue&type=script&lang=js&"
import style0 from "./MnemonicTip.vue?vue&type=style&index=0&id=28cfac5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cfac5a",
  null
  
)

export default component.exports